var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',_vm._g({staticClass:"eBtn",class:( _obj = {}, _obj[(_vm.variant + "Btn")] = true, _obj.dense = _vm.dense, _obj ),attrs:{"size":_vm.dense ? 'sm' : ''}},_vm.$listeners),[(_vm.preIcon)?_c('BaseIcon',{staticClass:"mx-1",attrs:{"name":_vm.preIcon}}):_vm._e(),_vm._t("default"),(_vm.icon)?_c('BaseIcon',{staticClass:"mx-1",attrs:{"name":_vm.icon}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }